import bootLayout from 'static/script/app/boot/boot-layout';
import riot from 'riot';
import context from 'static/script/app/ui/checkout2/context/context';
import 'static/output/script/riot-core-tags';
import 'static/script/app/ui/checkout2/braintree-payment-core';
import 'static/script/app/ui/checkout2/braintree-integration';

module.exports = initData => {
    bootLayout(initData);

    context.model = initData.pageSpecificData.Context;

    riot.mount('checkout-summary', { model: initData.pageSpecificData.Summary });
    riot.mount('checkout-payment', { model: initData.pageSpecificData.Payment });
    riot.mount('checkout-item', { model: initData.pageSpecificData.Item });
    riot.mount('checkout-shipping', { model: initData.pageSpecificData.Shipping });
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/checkout2.js